// extracted by mini-css-extract-plugin
module.exports = {"imageGrid":"imageGrid-module--image-grid--BoTYJ","col2":"imageGrid-module--col2--2Cq2H","triangle":"imageGrid-module--triangle--2aevv"};